import Component from './component';


export interface Props {
   password?: string;
   pwdLength?:number;
   translations?: any;
   checkIfValid?: (pwdTests:Validation)=> void;
}
export interface Validation {
   length: boolean;
   lowercase:boolean;
   uppercase: boolean;
   digits: boolean;
   symbols: boolean;
}
Component.defaultProps = {
};

export default Component;